<template>
  <div v-if="showLoading">
    <div id="loading-grid">
      <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66">
        <circle
          class="path"
          fill="none"
          stroke-width="6"
          stroke-linecap="round"
          cx="33"
          cy="33"
          r="30"
        ></circle>
      </svg>
    </div>
  </div>
  <div v-else>
    <div class="vx-row">
      <div class="vx-col w-full hide-in-print mb-4">
        <vs-button
          type="button"
          class="float-left mx-2 mb-2"
          style="background-color: #444"
          @click.prevent="backToCurrentGrid()"
          >{{ $t("Back") }}</vs-button
        >
        <vs-button
          class="vs-button float-right mr-4"
          v-if="partialDetails.dischargePermissionState == DischargePermissionState.Pending"
          @click="confirmDischargePermission()"
          :disabled="disabled"
          id="l-confirm-btn"
          >{{ $t("Confirm") }}</vs-button
        >
        <vs-button
          class="vs-button float-right mr-4"
          @click="showfile()"
          id="bg-info l-confirm-btn"
          >{{ $t("Attachments") }}</vs-button
        >
        <vs-button
          color="primary"
          icon-pack="feather"
          class="bg_green mx-4"
          type="filled"
          @click.prevent="PrintTable()"
          >{{ $t("PrintTableUnder") }}</vs-button
        >
        <vs-button
          class="vs-button float-right mr-4"
          v-if="
            partialDetails.dischargePermissionState == DischargePermissionState.Pending ||
            partialDetails.dischargePermissionState == DischargePermissionState.Partial
          "
          @click="onRejectPermissionButton()"
          id="l-reject-btn"
          >{{ $t("Reject") }}</vs-button
        >
        <router-link
          :to="{
            path:
              '/DischargePermissions/Label/' + partialDetails.stockDraftOrderId,
          }"
          class="vs-button purple float-right mt-0"
          style="padding: 0.85rem 2rem !important"
          v-has-permission="permission234"
        >
          {{ $t("Label") }}
        </router-link>
        <vs-button
          class="vs-button float-right ml-4"
          v-if="
            partialDetails.dischargePermissionState == DischargePermissionState.Pending ||
            partialDetails.dischargePermissionState == DischargePermissionState.Partial
          "
          @click="forceProcessDischargePermission()"
          id="m-reject-btn"
          >{{ $t("Close") }}</vs-button
        >
        <router-link
          v-if="
            partialDetails.partyType &&
            partialDetails.partyType.isAgent == 'true'
          "
          :to="{
            path: '/DraftOrders/Invoice/' + partialDetails.stockDraftOrderId,
          }"
          class="vs-button orange-btn float-right"
        >
          {{ $t("ViewRecipientInvoice") }}
        </router-link>
      </div>
    </div>
    <div class="vx-row" v-for="n in countOfPage" :key="n">
      <div class="vx-col w-full">
        <div class="vx-card mb-6" :class="forPrint ? 'separation_pages' : ''">
          <div
            class="vx-card__header"
            :style="n == 1 ? 'display:block' : 'display:none'"
            :class="forPrint ? 'ml-12' : ''"
          >
            <div
              class="flex vx-card__title py-2"
              style="height: 50px; width: 228px"
              :class="forPrint ? 'mt-12' : ''"
            >
              <barcode
                :value="partialDetails.basketId"
                :options="{ displayValue: false }"
              ></barcode>
            </div>
            <div
              class="flex vx-card__title w-full py-2"
              :class="forPrint ? 'mt-12' : ''"
            >
              <div class="w-1/3 flex p-2 is_border">
                <h5>{{ $t("CompanyName") }} :</h5>
                <h6 class="m-1">{{ partialDetails.partyType.partyName }}</h6>
              </div>
              <div class="w-1/3 flex p-2 is_border mx-2">
                <h5>{{ $t("OrderNumber") }} :</h5>
                <h6 class="m-1">{{ partialDetails.basketId }}</h6>
              </div>

              <div class="w-1/3 flex p-2 is_border">
                <h5>{{ $t("Date") }} :</h5>
                <h6 class="m-1">
                  {{
                    partialDetails.partialDischargePermissionsQueryDto[0]
                      .persianDateTime
                  }}
                </h6>
              </div>
            </div>
            <div class="w-full flex py-2">
              <div class="w-2/3 flex p-2 is_border">
                <h5>{{ $t("Address") }}:</h5>
                <h6 class="m-1">
                  استان
                  {{
                    partialDetails.recipientInfo.addressInfo.provinceInfo.name
                  }}
                  - شهر
                  {{
                    partialDetails.recipientInfo.addressInfo.provinceInfo
                      .cityName
                  }}
                  - {{ partialDetails.recipientInfo.addressInfo.address }}
                </h6>
              </div>
              <div class="w-1/3 flex p-2 is_border mr-2">
                <h5>{{ $t("PhoneNumber") }} :</h5>
                <h6 class="m-1">
                  {{
                    partialDetails.recipientInfo.mobileNumber
                      ? partialDetails.recipientInfo.mobileNumber
                      : partialDetails.recipientInfo.phoneNumber
                  }}
                </h6>
              </div>
            </div>
          </div>
          <div
            class="vx-card__collapsible-content vs-con-loading__container"
            :class="forPrint ? (n > 1 ? 'ml-12 mt-12' : 'ml-12') : ''"
          >
            <span class="mx-8 bolder">
              {{
                forPrint & (n != 1)
                  ? $t("OrderNumber") + " " + partialDetails.basketId
                  : ""
              }}
            </span>
            <div class="vx-card__body custom-tbl" id="discharge-permission-tbl">
              <vs-table :data="dataForEachPage" ref="table">
                <template slot="thead">
                  <vs-th style="width: 3%">{{ forPrint ? n : "" }}# </vs-th>
                  <vs-th style="width: 30%">{{ $t("ProductName") }}</vs-th>
                  <vs-th style="width: 17%">{{ $t("ItemCode") }}</vs-th>
                  <vs-th style="width: 17%">{{ $t("ModelNumber") }}</vs-th>
                  <vs-th style="width: 10%">{{ $t("WarehouseName") }}</vs-th>
                  <vs-th style="width: 10%" class="hide-in-print">{{
                    $t("ShelveName")
                  }}</vs-th>
                  <vs-th style="width: 10%">{{
                    $t("CountOfOperatorRequested")
                  }}</vs-th>
                  <vs-th style="width: 10%">{{ $t("CountOfCheckout") }}</vs-th>
                  <vs-th style="width: 10%">{{
                    $t("RemainingCountForCheckout")
                  }}</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    v-for="(tr, indextr) in data"
                    :data="tr"
                    :key="indextr"
                  >
                    <vs-td :data="data[indextr]">
                      {{ 10 * (n - 1) + parseInt(indextr) + 1 }}
                    </vs-td>
                    <vs-td
                      :data="
                        data[indextr].dischargePermissionProductInfoEvent
                          .productName
                      "
                    >
                      {{
                        data[indextr].dischargePermissionProductInfoEvent
                          .productName
                      }}
                    </vs-td>
                    <vs-td
                      :data="
                        data[indextr].dischargePermissionProductInfoEvent
                          .itemCode
                      "
                    >
                      {{
                        data[indextr].dischargePermissionProductInfoEvent
                          .itemCode
                      }}
                    </vs-td>
                    <vs-td
                      :data="
                        data[indextr].dischargePermissionProductInfoEvent
                          .modelNumber
                      "
                    >
                      {{
                        data[indextr].dischargePermissionProductInfoEvent
                          .modelNumber
                          ? data[indextr].dischargePermissionProductInfoEvent
                              .modelNumber
                          : "---"
                      }}
                    </vs-td>
                    <vs-td
                      :data="
                        data[indextr].partialDischargePermissionShelveInfoQuery
                          .storeName
                      "
                    >
                      {{
                        data[indextr].partialDischargePermissionShelveInfoQuery
                          .storeName
                      }}
                    </vs-td>
                    <vs-td
                      class="hide-in-print"
                      :data="
                        data[indextr].partialDischargePermissionShelveInfoQuery
                          .shelveName
                      "
                    >
                      {{
                        data[indextr].partialDischargePermissionShelveInfoQuery
                          .shelveName
                      }}
                    </vs-td>
                    <vs-td
                      :data="
                        data[indextr].partialDischargePermissionShelveInfoQuery
                          .countOfOperatorRequested
                      "
                    >
                      {{
                        data[indextr].partialDischargePermissionShelveInfoQuery
                          .countOfOperatorRequested
                      }}
                    </vs-td>
                    <vs-td
                      :data="
                        data[indextr].partialDischargePermissionShelveInfoQuery
                          .countOfCheckout
                      "
                    >
                      {{
                        data[indextr].partialDischargePermissionShelveInfoQuery
                          .countOfCheckout
                      }}
                    </vs-td>
                    <vs-td
                      :data="
                        data[indextr].partialDischargePermissionShelveInfoQuery
                          .remainingCountForCheckout
                      "
                    >
                      {{
                        data[indextr].partialDischargePermissionShelveInfoQuery
                          .remainingCountForCheckout
                      }}
                    </vs-td>
                  </vs-tr>
                  <vs-tr
                    :style="n != countOfPage ? 'display:none' : ''"
                    style="background-color: #007470 !important; color: white"
                  >
                    <vs-td>{{ $t("Sum") }}</vs-td>
                    <vs-td></vs-td>
                    <vs-td></vs-td>
                    <vs-td></vs-td>
                    <vs-td class="hide-in-print"></vs-td>
                    <vs-td></vs-td>
                    <vs-td>{{
                      partialDetails.sumOfCountOfOperatorRequested
                        ? partialDetails.sumOfCountOfOperatorRequested
                        : "---"
                    }}</vs-td>
                    <vs-td></vs-td>
                    <vs-td></vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
          <div
            class="button-row mb-4"
            :style="n != countOfPage ? 'display:none' : ''"
          >
            <vs-button
              color="danger"
              v-if="
                partialDetails.partialDischargePermissionsQueryDto[0]
                  .dischargePermissionState == DischargePermissionState.Confirm
              "
              type="gradient"
              icon-pack="feather"
              class="bordered-btn py-3 float-right hide-in-print"
              @click="onRejectPermissionButton()"
            >
              {{ $t("RejectDischargePermission") }}
            </vs-button>
            <div
              class="flex gap-4 justify-end"
              v-if="
                partialDetails.partialDischargePermissionsQueryDto[0]
                  .dischargePermissionState == DischargePermissionState.Confirm ||
                partialDetails.partialDischargePermissionsQueryDto[0]
                  .dischargePermissionState == DischargePermissionState.Partial
              "
            >
              <router-link
                v-for="store of stores"
                :key="store.id"
                :to="{
                  path:
                    '/DischargePermissions/DischargeCheckOut/' +
                    partialDetails.partialDischargePermissionsQueryDto[0].id,
                  query: {
                    storeId: store.id,
                    isProcess: partialDetails.isProcess,
                  },
                }"
                class="hide-in-print vs-component vs-button float-right vs-button-primary vs-button-filled white mb-2"
              >
                {{
                  stores.length > 1
                    ? $t("DischargeCheckOut") + " " + store.name
                    : $t("DischargeCheckOut")
                }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <files-and-attachments-popup
      :show="isShowFile"
      @finish="onfinish"
      :basketId="basketId"
    ></files-and-attachments-popup>
    <description-popup
      :show="isShowDescriptionPopup"
      @finish="onfinish"
      :referencePageInfo="referencePageInfo"
      :dischargePermissionId="dischargePermissionId"
    ></description-popup>
  </div>
</template>
<style lang="scss">
@page {
  size: portrait;
}
.separation_pages {
  height: 26.3cm;
}
.white {
  color: #fff !important;
}
.is_border {
  border: 1px solid black;
  border-radius: 7px;
}
h5 {
  font-weight: bolder;
}
.purple {
  background: #836dd8 !important;
  color: #fff !important;
}

.purple:hover {
  webkit-box-shadow: 0 8px 25px -8px #836dd8;
  box-shadow: 0 8px 25px -8px #836dd8;
}

.button-row {
  display: inline-block;
  width: 100%;
  padding: 0 1rem;
}
</style>
<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/_label.scss";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import FilesAndAttachmentsPopup from "./FilesAndAttachmentsPopup.vue";
import DescriptionPopup from "./DescriptionPopup.vue";
import VueBarcode from "@xkeshi/vue-barcode";
import { QRCanvas } from "qrcanvas-vue";


export default {
  name: "warehouseManagement_DischargePermission_Create",
  data() {
    return {
    DischargePermissionState : {
    Pending: 0,
    Confirm: 1,
    Partial: 2,
    Processed: 3,
    Reject: 10,
  },
      referencePageInfo: {
        tabIndex: this.$route.params.tabIndex,
        numberRowsPerPage: this.$route.query.numberRowsPerPage,
      },
      showLoading: true,
      basketId: "",
      partialDetails: {},
      dataForEachPage: [],
      permission234: "GetRecipientInfoByDraftOrderId",
      loadTable: false,
      forPrint: false,
      countOfPage: 1,
      isShowDescriptionPopup: false,
      disabled: false,
      dischargePermissionId: this.$route.params.id,
      isShowFile: false,
      model: {
        dischargePermissionId: "",
        description: "",
      },
      stores: [],
    };
  },
  components: {
    FilesAndAttachmentsPopup,
    DescriptionPopup,
    QRCanvas,
    VueBarcode,
  },
  mounted() {
    this.load();
  },
  created() {
    window.onafterprint = () => {
      this.forPrint = false;
    };
  },
  methods: {
    ...mapActions({
      fetchSingle: "dischargePermissions/partialDischargePermissions",
      getSingleDischargePermission:
        "dischargePermissions/getSingleDischargePermission",
      confirm: "dischargePermissions/confirmDischargePermission",
      updateForceProcessDischargePermission:
        "dischargePermissions/updateForceProcessDischargePermission",
      reject: "dischargePermissions/rejectDischargePermission",
    }),
    load() {
      var id = this.$route.params.id;
      this.fetchSingle(id)
        .then((r) => {
          this.partialDetails = r;
          this.dataForEachPage = [];
          this.partialDetails.partialDischargePermissionsQueryDto.forEach(
            (item) => {
              this.stores.push({ name: item.storeName, id: item.storeId });
              item.partialDischargePermissionItemsQueryDto.forEach(
                (innerItem) => {
                  this.dataForEachPage.push(innerItem);
                }
              );
            }
          );
          this.loadTable = true;
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    forceProcessDischargePermission() {
      let forceProcessModel = {
        dischargePermissionId: this.dischargePermissionId,
      };
      this.updateForceProcessDischargePermission(forceProcessModel).then(() => {
        setTimeout(() => {
          this.$router.push({
            path: "/DischargePermissions/Index",
            query: {
              referencePageInfo: this.referencePageInfo,
            },
          });
        }, 3000);
      });
    },
    showfile() {
      this.isShowFile = true;
      this.basketId = this.partialDetails.basketId;
    },
    backToCurrentGrid() {
      this.$router.push({
        path: "/DischargePermissions/Index",
        query: {
          referencePageInfo: this.referencePageInfo,
        },
      });
    },
    confirmDischargePermission() {
      this.isShowDescriptionPopup = true;
    },
    PrintTable() {
      this.forPrint = true;
      setTimeout(() => {
        window.print();
      }, 200);
    },
    async checkIfDischargeIsProcessing() {
      const id = this.$route.params.id;
      return this.getSingleDischargePermission(id).then((r) => r.isProcess);
    },
    async onRejectPermissionButton() {
      const isProccesing = await this.checkIfDischargeIsProcessing();
      this.openRejectDischargePermissionModal(isProccesing);
    },
    openRejectDischargePermissionModal(isProccesing) {
      let title = "آیا از رد این مجوز خروج اطمینان دارید؟";
      if (isProccesing) {
        title = "انبار فرایند پردازش خروج این سفارش را شروع کرده است، " + title;
      }
      this.$swal({
        title: title,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.rejectDischargePermission();
        }
      });
    },
    openSuccessModal() {
      this.$swal({
        position: "center-center",
        type: "success",
        text: "مجوز خروج با موفقیت رد شد!",
        showConfirmButton: false,
        timer: 2000,
      });
    },
    rejectDischargePermission() {
      this.reject(this.dischargePermissionId).then(() => {
        this.openSuccessModal();
        setTimeout(() => {
          this.$router.push({
            path: "/DischargePermissions/Index",
            query: {
              referencePageInfo: this.referencePageInfo,
            },
          });
        }, 3000);
      });
    },
    onfinish() {
      this.isShowFile = false;
      this.isShowDescriptionPopup = false;
    },
    numberOfPrintPages(allData) {
      let countOfData =
        allData.partialDischargePermissionsQueryDto[0]
          .partialDischargePermissionItemsQueryDto.length;
      this.countOfPage = Math.ceil(countOfData / 10);
      for (let i = 0; i < this.countOfPage; i++) {
        this.dataForEachPage[i] =
          allData.partialDischargePermissionsQueryDto[0].partialDischargePermissionItemsQueryDto.slice(
            10 * i,
            10 * i + 10
          );
      }
    },
  },
  watch: {
    // forPrint() {
    //   if (this.forPrint) {
    //     this.numberOfPrintPages(this.partialDetails);
    //   }
    // },
  },
};
</script>
